export default __webpack_public_path__ + "static/media/blanket-large.6ccba50c.png";